import { inject, Injectable } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { AuthService } from '../services';

import { CORE_API_BASE_URL } from '../../core.tokens';
import { take } from 'rxjs/operators';

export const provideAuthInterceptor = () => (
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
  }
);

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  private readonly apiUrl = inject(CORE_API_BASE_URL);
  private auth = inject(AuthService);


  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.auth.token$.pipe(
      take(1),
      switchMap((token) => {
        request = request.clone({
          url: this.setUrl(request.url),
        });

        if (token && request.url.startsWith(this.apiUrl)) {
          request = request.clone({
            setHeaders: {
              authorization: `Bearer ${ token }`,
            },
          });
        }

        return next.handle(request);
      }),
    );
  }

  private setUrl(url: string): string {
    if (url.startsWith('@api_host')) {
      return url.replace('@api_host', this.apiUrl);
    }

    return url;
  }

}
